<template lang="pug">
.app.flex-row.align-items-center
  .container
    b-row.justify-content-center
      b-col(md="4")
        b-card-group
          b-card.p-4(no-body="")
            b-card-body
              h1 Login
              p.text-muted ログインしてください
              .input-group.mb-3
                span.input-group-addon
                  i.icon-user
                input.form-control(type="text", v-model='login_id', placeholder="Username")
              .input-group.mb-4
                span.input-group-addon
                  i.icon-lock
                input.form-control(type="password", v-model='password', placeholder="Password")
              b-row
                b-col(cols="6")
                  b-button.px-4(variant="primary",@click='login') Login
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'

export default {
  name: 'Login',
  data () {
    return {
      login_id: '',
      password: ''
    }
  },
  created () {
    // console.log(this.GET_LOGIN)
  },
  methods: {
    ...mapActions([
      'SAVE_LOGIN_AUTH',
      'SAVE_LOGIN_USERDATA'
    ]),
    login () {
      return axios({
        method: 'POST',
        url: '/admin/login',
        baseURL: process.env.API_BASE_URL,
        data: ({login_id: this.login_id, password: this.password})
      }).then((res) => {
        // console.dir(res.data)
        this.SAVE_LOGIN_AUTH(res.data.api_token)
        this.SAVE_LOGIN_USERDATA(res.data)
        if (this.GET_AUTH) {
          this.$router.push({path: '/dashboard'})
        }
      }).catch(function (error) {
        console.log(error)
      })
    }
  },
  computed: {
    ...mapGetters([
      'GET_AUTH'
    ])
  }
}
</script>

<style>
  .el-header, .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }
  
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    text-align: center;
    line-height: 200px;
  }
  
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
    line-height: 160px;
  }
  
  body > .el-container {
    margin-bottom: 40px;
  }
  
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }
  
  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
</style>




// WEBPACK FOOTER //
// src/views/Login.vue